import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/motion';
type NoetivraModuleProps = {
  id: string;
  name: string;
  headline: string;
  paragraphs: string[];
  tone?: 'white' | 'muted';
  note?: string;
  children?: React.ReactNode;
};
export function NoetivraModule({
  id,
  name,
  headline,
  paragraphs,
  tone = 'white',
  note,
  children
}: NoetivraModuleProps) {
  return <section id={id} aria-labelledby={`${id}-title`} className={`${tone === 'muted' ? 'bg-surface-bg' : 'bg-white'} border-t border-line py-20 lg:py-28 scroll-mt-20`} data-id="element-1021" data-mp="hx1tti6c102p">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1022" data-mp="rmlemtdlv407">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1023" data-mp="rn4snz04x88y">
          <div className="lg:col-span-5" data-id="element-1024" data-mp="vn573jn8hjg0">
            <p className="text-sm font-medium text-teal mb-3" data-id="element-1025" data-mp="10njjfdvvbfju">{name}</p>
            <h2 id={`${id}-title`} className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1026" data-mp="10l6qk5oknks0">
              {headline}
            </h2>
          </div>
          <div className="lg:col-span-7 space-y-5" data-id="element-1027" data-mp="3snannukdympt">
            {paragraphs.map((paragraph, index) => <p key={paragraph} className={index === 0 ? 'text-xl text-ink-dark leading-relaxed' : 'text-lg text-ink-muted leading-relaxed'} data-id="element-1028" data-mp="3olfds1oe310f" data-mpi={index}>
                {paragraph}
              </p>)}
          </div>
        </motion.div>
        {children && <div className="mt-12 lg:mt-14" data-id="element-1029" data-mp="g65fl4nmefxx">{children}</div>}
        {note && <motion.p {...fadeUp} className="mt-10 lg:ml-[calc(41.666%+1.667rem)] border-l-4 border-teal pl-6 text-base text-ink-dark leading-relaxed" data-id="element-1030" data-mp="bff91o3gk71n">
            {note}
          </motion.p>}
      </div>
    </section>;
}